import Particles from "react-particles-js";
import React from "react";

export const script_set = [
    {
        scene: 1,
        img_load:true,
        title: "으스스정글으스스",
        msg: "어젯밤은 분명 침대에서 잠들었는데...\n당신이 잠에서 깨어난 곳은\n영화에서나 볼법한 정글이었습니다.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
            }
        ],
    },
    {
        scene: 2,
        script_scene:1,
        img_load:true,
        title: "무슨 소리일까?",
        msg: "안 그래도 어두컴컴 으스스한데\n" +
            "어둠속에서 소리가 들려요.\n" +
            "기묘한 소리의 정체는 무엇일까요?",
        choice_set: [
            {
                point: 2,
                sound_scene:1,
                title: "새 소리",
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Owl.png",
                dom_animation: "fade_right_slide",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 70
                },
                position: {
                    zIndex: 10,
                    top: "32%",
                    left: "15%",
                },
                img_style: {
                    height: "15vh",
                },
                next_msg: {
                    title: "새 소리",
                    msg: "새 소리였군요.\n" +
                        "\"새가 살아있는 사람을 공격하진 않겠지\"\n" +
                        "라고 생각하며 마음을 추스려봅니다.\""
                }
            },
            {
                point: 3,
                sound_scene:1,
                title: "들짐승 소리",
                title_is_top: true,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Panther.png",
                dom_animation: "up_slide",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 70
                },
                position: {
                    zIndex: 8,
                    bottom: "12%",
                    right: "7%"
                },
                img_style: {
                    height: "25vh",
                },
                next_msg: {
                    title: "들짐승 소리",
                    msg: "저런, 들짐승 소린가봐요.\n" +
                        "작고 귀여운 고양이라면 좋을텐데...\n" +
                        "그러길 바래야겠네요."
                }
            },
            {
                point: 1,
                sound_scene:1,
                title: "풀벌레 소리",
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Insects.png",
                img_animation: "rotate_circle_and_blink",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 70
                },
                position: {
                    zIndex: 10,
                    right: '10%',
                    top: '35%',
                },
                img_style: {
                    height: "5vh",
                },
                next_msg: {
                    title: "풀벌레 소리",
                    msg: "풀벌레 소리였군요.\n" +
                        "어느 곳을 가든 풀벌레 소리는 익숙하죠."
                }
            },
            {
                point: 0,
                sound_scene:1,
                title: "나뭇잎 소리",
                title_is_top: true,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_1/000-OB-Leaf.png",
                img_animation: "rotate_small",
                dom_animation: "right_slide",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 70
                },
                position: {
                    zIndex: 10,
                    left: 0,
                    bottom: 0,
                },
                img_style: {
                    height: "20vh",
                },
                next_msg: {
                    title: "나뭇잎 소리",
                    msg: "바스락 나뭇잎소리\n" +
                        "바람이 부는걸까요 아니면...\n" +
                        "누군가 나뭇잎을 밟은 걸까요?"
                }
            },
        ]
    },
    {
        scene: 3,
        img_load:true,
        title: "불안한 마음",
        background: "",
        msg: "주위는 온통 어둠뿐...\n" +
            "아무도 없는 것 같아요.\n" +
            "눈을 감고, 마음의 평화...",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
            }
        ]
    },
    {
        scene: 4,
        script_scene:2,
        img_load:true,
        title: "지금 필요한 것",
        background: <img className="scene_two fade_in" alt="layer"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
        msg: "지금 이순간 가장 필요한건 뭘까요?\n" +
            "당신이 가져왔더라면,\n" +
            "했으면 하는 물건이 이 중에 있나요?",
        choice_set: [
            {
                point: 4,
                sound_scene:2,
                title: "손전등",
                title_is_top: true,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Light-min.png",
                img_animation: "short_rotate_xsmall",
                choice_event: 'zoom_object',
                choice_event_option: {
                    img_animation: "fade_in",
                    position: {
                        zIndex: 10,
                        top: "40%",
                        left: "42%"
                    },
                    img_style: {
                        height: "21vh",
                    }
                },
                position: {
                    zIndex: 10,
                    right: "10%",
                    bottom: "14%",
                },
                img_style: {
                    height: "13vh",
                },
                next_msg: {
                    background: <img className="scene_two fade_opacity" alt="layer"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
                    title: "손전등이다!",
                    msg: "눈을 뜨니, 손전등이 옆에 있어요.\n" +
                        "앞이 보이니 마음이 한결 편해요."
                }
            },
            {
                point: 1,
                sound_scene:2,
                title: "핸드폰",
                title_is_top: true,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Porn-min.png",
                img_animation: "short_rotate_ssmall",
                choice_event: 'zoom_object',
                choice_event_option: {
                    img_animation: "fade_in",
                    position: {
                        zIndex: 10,
                        top: "46%",
                        left: "33%"
                    },
                    img_style: {
                        height: "10vh",
                    }
                },
                position: {
                    zIndex: 10,
                    left: "23%",
                    bottom: "10%",
                },
                img_style: {
                    height: "4vh",
                },
                next_msg: {
                    background: <img className="scene_two fade_opacity" alt="layer"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
                    title: "핸드폰이다!",
                    msg: "눈을 뜨니, 핸드폰이 옆에 있어요.\n" +
                        "터지지도 않는 핸드폰을 고르셨어요.\n" +
                        "그래도 후레쉬정돈 쓸 수 있겠죠."
                }
            },
            {
                point: 2,
                sound_scene:2,
                title: "라이터",
                title_is_top: true,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Lighter-min.png",
                img_animation: "short_rotate_small",
                choice_event: 'zoom_object',
                choice_event_option: {
                    img_animation: "fade_in",
                    position: {
                        zIndex: 10,
                        top: "46%",
                        left: "47%"
                    },
                    img_style: {
                        height: "13vh",
                    }
                },
                position: {
                    zIndex: 10,
                    left: "2%",
                    bottom: "12%",
                },
                img_style: {
                    height: "7vh",
                },
                next_msg: {
                    background: <img className="scene_two fade_opacity" alt="layer"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
                    title: "라이터등장!",
                    msg: "눈을 뜨니, 라이터가 옆에 있어요.\n" +
                        "여기는 숲이니까 불킬 때\n" +
                        "조심하는거 잊지말아요!"
                }
            },
            {
                point: 0,
                sound_scene:2,
                title: "다용도칼",
                title_is_top: true,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-SwissKnife-min.png",
                img_animation: "short_rotate_small",
                choice_event: 'zoom_object',
                choice_event_option: {
                    img_animation: "fade_in",
                    position: {
                        zIndex: 10,
                        top: "55%",
                        left: "30%"
                    },
                    img_style: {
                        height: "4vh",
                    }
                },
                position: {
                    zIndex: 10,
                    right: "4%",
                    top: "51%",
                },
                img_style: {
                    height: "2vh",
                },
                next_msg: {
                    background: <img className="scene_two fade_opacity" alt="layer"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
                    title: "싸늘한 비수가 날아와",
                    msg: "눈을 뜨니, 군용칼이 옆에 있어요.\n" +
                        "서슬퍼런 칼을 손에 쥐니\n" +
                        "다 이길 수 있을 것 같은 기분."
                }
            },
            {
                point: 3,
                sound_scene:2,
                title: "두터운 옷",
                title_is_top: false,
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-OB-Jacket-min.png",
                img_animation: "short_rotate_xxsmall",
                choice_event: 'zoom_object',
                choice_event_option: {
                    position: {
                        zIndex: 10,
                        top: "38%",
                        left: "22%"
                    },
                    img_style: {
                        height: "27vh",
                    }
                },
                position: {
                    zIndex: 10,
                    top: "40%",
                    left: 0
                },
                img_style: {
                    height: "25vh",
                },
                next_msg: {
                    background: <img className="scene_two fade_opacity" alt="layer"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
                    title: "이 옷이다!",
                    msg: "눈을 뜨니, 두터운 옷이 있어요.\n" +
                        "이렇게 두툼한 옷이면,\n" +
                        "겨울이 무섭지 않겠어요."
                }
            },
        ]
    },
    {
        scene: 5,
        img_load:true,
        title: "아..이너피스",
        background: <img className="scene_two fade_out" alt="layer"
                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_2/001-BG-min.png"/>,
        msg: "뭔가 손에 쥐니까 그래도 편한기분\n" +
            "다 괜찮아요. 어차피 꿈이잖아요.\n" +
            "언제 이런 곳에 와보겠어요.",
        choice_set: [
            {
                title: "다음",
                dom_animation: "fade_in",
            }
        ]
    },
    {
        scene: 6,
        script_scene:3,
        img_load:true,
        title: "함께하는 정글",
        background: [
            <div key={0} className="main_dissolve_background start_fade_in" style={{zIndex: 5}}/>
        ],
        msg: "휴가 온거라고 편하게 생각해요!\n" +
            "이 좋고 으스스한 곳에 데려올\n" +
            "사람이 있다면 좋을텐데...",
        choice_set: [
            {
                point: 0,
                title: "애인",
                dom_animation: "fade_in",
                choice_event: '',
                next_msg: {
                    background: [
                        <div className="main_dissolve_background" style={{zIndex: 5}}/>
                    ],
                    title: "... 부럽다.",
                    msg: "부럽네요.\n제가 할 말은 오직 그뿐."
                },
            },
            {
                point: 1,
                title: "친구",
                dom_animation: "fade_in",
                choice_event: '',
                next_msg: {
                    background: [
                        <div className="main_dissolve_background" style={{zIndex: 5}}/>
                    ],
                    title: "친구",
                    msg: "그렇죠!\n" +
                        "여행은 친구랑 가야죠!\n" +
                        "애인이랑 가는거 아니죠!"
                }
            },
            {
                point: 2,
                title: "Brother or Sister",
                dom_animation: "fade_in",
                choice_event: '',
                next_msg: {
                    background: [
                        <div className="main_dissolve_background" style={{zIndex: 5}}/>
                    ],
                    title: "브로~",
                    msg: "죽을 똥 살 똥 싸워도\n" +
                        "서로를 가장 잘아는 사람이니까!"
                }
            },
            {
                point: 3,
                title: "엄빠",
                dom_animation: "fade_in",
                choice_event: '',
                next_msg: {
                    background: [
                        <div className="main_dissolve_background" style={{zIndex: 5}}/>
                    ],
                    title: "효도관광 맞죠?",
                    msg: "부모님과 함께 온 정글이...\n" +
                        "어두컴컴 으스스 정글은 아니죠?\n" +
                        "휴가온 듯 편안한 정글 맞죠!"
                }
            }
        ],
    },
    {
        scene: 7,
        script_scene:4,
        sound_scene:3,
        img_load:true,
        title: "함께하는 여행",
        msg: "소중한 사람과 함께하는 여행\n" +
            "좀 더 탐험해 보기로 해요.\n" +
            "어디로 가볼까요?",
        background: [
            <img key={0} className="background_1" alt="layer"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-01-bg-min.png"/>,
            <img key={1} className="background_2 scene_3_left" alt="layer"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-Front-Left-min.png"/>,
            <img key={2} className="background_4 scene_3_right" alt="layer"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_3/002-Front-Right-min.png"/>,
            <div key={3} className="main_dissolve_background start_fade_in" style={{zIndex: 5}}/>
        ],
        choice_set: [
            {
                point: 2,
                sound_scene:4,
                title: "폭포",
                sound_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/warter_fall.wav",
                title_is_top: true,
                dom_animation: "fade_in",
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/object/alpha_squre.png",
                choice_event: '',
                img_style: {
                    height: "13vh",
                },
                position: {
                    zIndex: 10,
                    top: "41%",
                    left: "6%"
                },
                next_msg: {
                    background: [
                        <img className="background_1 scene_4_scale_down_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-BG-min.png"/>,
                        <img className="background_4 scene_4_upslide" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-FG-min.png"/>,
                        <img className="scene_4_wave_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-Wave-0.png"/>,
                        <img className="scene_4_wave_2" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-Wave-1.png"/>,
                        <img className="scene_4_wave_3" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Waterfall-Wave-2.png"/>,
                        <div className="fade_in_2s"
                             style={{width: "100%", top: "70%", zIndex: 3, position: "absolute"}}>
                            <div className="fade_in_2s" style={{width: "42vh", height: "10vh", margin: 'auto'}}>
                                <Particles width="100%" height="12vh" params={{
                                    "particles": {
                                        shadow: {
                                            enable: true,
                                            color: "#3CA9D1",
                                            blur: 10
                                        },
                                        "color": {
                                            value: "#ffffff"
                                        },
                                        "number": {
                                            "value": 30,
                                        },
                                        "line_linked": {
                                            "enable": false
                                        },
                                        "size": {
                                            "value": 40,
                                            "random": true,
                                            "anim": {
                                                "speed": 40,
                                                "size_min": 0.3
                                            }
                                        },
                                        "collisions": {
                                            "enable": false,
                                        },
                                        "move": {
                                            "direction": "none",
                                            "random": true,
                                            "speed": 15,
                                            "out_mode": "bounce"
                                        }
                                    }
                                }}/>
                            </div>
                        </div>,
                        <div className="main_dissolve_background start_fade_in" style={{zIndex: 5}}/>
                    ],
                    title: "폭포",
                    msg: "세상에서 가장 높은 폭포라해도\n" +
                        "믿을 수 있을 것 같은 높이!\n" +
                        "가슴이 탁 트이네요."
                },
            },
            {
                point: 1,
                sound_scene:4,
                title: "고대유적",
                title_is_top: true,
                dom_animation: "fade_in",
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/object/alpha_squre.png",
                choice_event: '',
                img_style: {
                    height: "13vh",
                },
                position: {
                    zIndex: 10,
                    top: "36%",
                    right: "9%"
                },
                next_msg: {
                    background: [
                        <img className="background_1 scene_4_scale_down_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Ancients-BG-min.png"/>,
                        <img className="background_2 scene_4_upslide" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Ancients-FG-min.png"/>,
                        <img className="scene_4_bird_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-bird.png"/>,
                        <img className="scene_4_bird_2" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-bird.png"/>,
                        <div className="main_dissolve_background start_fade_in" style={{zIndex: 5}}/>
                    ],
                    title: "고대왕국의 유적지",
                    msg: "아마 예전에 번성했던 왕국이\n" +
                        "있던 자리 였을까요?\n" +
                        "영원한 건 없는 것 같아 씁씁하네요."
                },
            },
            {
                point: 3,
                sound_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/river.wav",
                sound_scene:4,
                title: "강",
                title_is_top: false,
                dom_animation: "fade_in",
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/object/alpha_squre.png",
                choice_event: '',
                img_style: {
                    height: "13vh",
                },
                position: {
                    zIndex: 10,
                    top: "56%",
                    right: "25%"
                },
                next_msg: {
                    background: [
                        <img className="background_1 fade_in" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Lake-BG-min.png"/>,
                        <img className="background_4 scene_4_upslide" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Lake-FG-min.png"/>,
                        <div className="water_flow_1"/>,
                        <div className="water_flow_2"/>,
                        <div className="water_flow_3"/>,
                        <div className="water_flow_4"/>,
                        <div className="water_flow_5"/>,
                        <div className="water_flow_6"/>,
                        <img className="scene_4_fish_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Fish.png"/>,
                        <img className="scene_4_fish_2" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Fish.png"/>,
                        <div className="main_dissolve_background start_fade_in" style={{zIndex: 5}}/>
                    ],
                    title: "깊은 강",
                    msg: "시원한 바람에 이끌려 도착한 강\n" +
                        "강물이 흐르는 방향을 따라\n" +
                        "무작정 걷다보니 걱정도 사라지네요."
                },
            },
            {
                point: 0,
                sound_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/sound/cave.wav",
                sound_scene:4,
                title: "동굴",
                title_is_top: false,
                dom_animation: "fade_in",
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/object/alpha_squre.png",
                choice_event: '',
                img_style: {
                    height: "13vh",
                },
                position: {
                    zIndex: 10,
                    top: "67%",
                    left: "6%"
                },
                next_msg: {
                    background: [
                        <img className="background_1 scene_4_scale_down_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Cave-BG-min.png"/>,
                        <img className="background_4 scene_4_scale_down_2" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-Cave-FG-min.png"/>,
                        <img className="scene_4_bat_1" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Bat.png"/>,
                        <img className="scene_4_bat_2" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Bat.png"/>,
                        <img className="scene_4_bat_3" alt="layer"
                             src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_4/002-OB-Bat.png"/>,
                        <Particles style={{zIndex: 3, position: "absolute"}} params={{
                            "particles": {
                                shadow: {
                                    enable: true,
                                    color: "#ffffff",
                                    blur: 5
                                },
                                "color": {
                                    value: "#80fd5d"
                                },
                                "number": {
                                    "value": 20,
                                    "density": {
                                        "enable": false
                                    }
                                },
                                "line_linked": {
                                    "enable": false
                                },
                                "size": {
                                    "value": 8,
                                    "random": true,
                                    "anim": {
                                        "speed": 4,
                                        "size_min": 0.3
                                    }
                                },
                                "move": {
                                    "random": true,
                                    "speed": 1,
                                    "direction": "top",
                                    "out_mode": "out"
                                }
                            }
                        }}/>,
                        <div className="main_dissolve_background start_fade_in" style={{zIndex: 5}}/>
                    ],
                    title: "동굴",
                    msg: "입구가 굉장히 멋진 동굴이에요.\n" +
                        "웅장함에 이끌려 향한 동굴\n" +
                        "멋지게 솟은 종유석을보니,\n" +
                        "오길 잘 한 것 같네요."
                },
            }
        ]
    },
    {
        scene: 8,
        script_scene:5,
        img_load:true,
        title: "끝이 보여요.",
        msg: "멀리 보이던 산이 가까이 있네요.\n" +
            "힘겹게 산위로 올라가서\n" +
            "내려다 본 전경. 여긴...어디죠?",
        choice_set: [
            {
                point: 3,
                title: "아프리카",
                dom_animation: "fade_in",
                next_msg: {
                    title: "아프리카",
                    msg: "광할한 사바나와 열대림이\n" +
                        "공존하는 아프리카 였군요!"
                }
            },
            {
                point: 0,
                title: "인도",
                dom_animation: "fade_in",
                next_msg: {
                    title: "인도",
                    msg: "역시 정글하면 인도죠!\n" +
                        "왠지 모글리가 숨어있을 것 같아요."
                }
            },
            {
                point: 1,
                title: "아마존",
                dom_animation: "fade_in",
                next_msg: {
                    title: "아마존",
                    msg: "역시 정글하면 아마존!\n" +
                        "아마존이야말로 정글 그 자체죠!"
                }
            },
            {
                point: 2,
                title: "동남아시아",
                dom_animation: "fade_in",
                next_msg: {
                    title: "동남아시아",
                    msg: "많은 나라가 모여있는 만큼\n" +
                        "다양한 문화와 다양한 생태가\n" +
                        "공존하고 있지요!"
                }
            },
        ]
    },
    {
        scene: 9,
        script_scene:6,
        img_load:true,
        title: "안녕, 정글",
        msg: "이제는 정말 떠나야할 때,\n" +
            "어떤 기분이 들어요?",
        choice_set: [
            {
                point: 2,
                sound_scene:5,
                title: "탈출이다!",
                dom_animation: "fade_in",
                next_msg: {
                    title: "탈출이다!!!",
                    msg: "지긋지긋한 모험이였어요.\n" +
                        "빨리 결과나 보여달라구요ㅠㅠ?\n" +
                        "이제 끝나가요 ㅠㅠ"
                }
            },
            {
                point: 1,
                sound_scene:5,
                title: "아쉬워.",
                dom_animation: "fade_in",
                next_msg: {
                    title: "또 만나",
                    msg: "너무 아쉬워 하지 말아요!\n" +
                        "다음에 더 재밌는 여행으로 돌아올게요.\n" +
                        "자 이제..."
                }
            },
            {
                point: 0,
                sound_scene:5,
                title: "즐거웠어.",
                dom_animation: "fade_in",
                next_msg: {
                    title: "좋은 추억",
                    msg: "즐거운 여정이였다니 다행이네요!\n" +
                        "다음엔 더 재밌는 여행 준비할게요!\n" +
                        "자 이제...!"
                }
            },
        ]
    },
    {
        scene: 10,
        script_scene:7,
        img_load:true,
        title: "흔적 남기기",
        msg: "정글 이야기를 기록한다면...\n" +
            "어디에 적는게 좋을까요?",
        choice_set: [
            {
                point: 0,
                title: "SNS",
                title_style: {
                    position: "absolute",
                    bottom: 0,
                    right: "-30px",
                },
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Stable-Phone.png",
                dom_animation: "short_rotate_xsmall",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 60
                },
                position: {
                    zIndex: 10,
                    bottom: "4%",
                    right: "10%",
                },
                img_style: {
                    height: "10vh",
                },
                next_msg: {
                    img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Animated-Phone.png",
                    background: [
                        <div className="half_dissolve_background"/>
                    ],
                    title: "문제야 문제~",
                    msg: "이 놈의 정보화시대엔\n" +
                        "여읔시 SNS죠.\n" +
                        "#정글#좋반#쫄지마키안커"
                }
            },
            {
                point: 2,
                title: "공책",
                title_style: {
                    position: "absolute",
                    bottom: "-30px",
                    left: "50px",
                },
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Stable-Note.png",
                dom_animation: "short_rotate_xxsmall",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 40
                },
                position: {
                    zIndex: 8,
                    bottom: "5%",
                    left: 0
                },
                img_style: {
                    height: "13vh",
                },
                next_msg: {
                    img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Animated-Note.png",
                    background: [
                        <div className="half_dissolve_background"/>
                    ],
                    title: "사각사각 쓰는 맛",
                    msg: "손으로 적는 맛을 잊지 않는 것\n" +
                        "그만큼 즐거운 기억으로\n" +
                        "남았으면 좋겠어요-!"
                }
            },
            {
                point: 1,
                title: "포스트잇",
                title_style: {
                    position: "absolute",
                    top: "-20%",
                    left: "35%"
                },
                img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Stable-Poit.png",
                img_animation: "short_rotate_small",
                choice_event: 'zoom',
                choice_event_option: {
                    top: 0
                },
                position: {
                    zIndex: 10,
                    left: 0,
                    top: '53%',
                },
                img_style: {
                    height: "17vh",
                },
                next_msg: {
                    img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/scene/scene_7/004-OB-Animated-Poit.png",
                    background: [
                        <div className="half_dissolve_background"/>
                    ],
                    title: "포스트잇",
                    msg: "작은 종이 쪼가리에 적고\n" +
                        "모니터나 냉장고에 붙여두면\n" +
                        "두고 두고 볼지도..\n" +
                        "혹은 버리게 될지도..."
                }
            }
        ]
    },
    {
        scene: 11,
        img_load:true,
        title: "결과발표!",
        msg: "긴 테스트가 끝났어요. 이제\n" +
            "과연 당신은 어떤\n" +
            "쫄보 유형인지 보여드릴게요!",
        is_last: true,
        choice_set: [
            {
                title: "결과보기",
                dom_animation: "fade_in_2s",
            }
        ]
    }
];

export const result_set = [
    {
        sub_title: "쏀 척하는 겁쟁이🎵",
        title: "다 살아본 호랑이",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Tiger-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Tiger-Web-FG-min.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Tiger-Insta.png",
        effect: ["shining"],
        pc_obj_img_set: [
            <img key={1} className="result_3_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Tiger-Animated.png"
                 alt="background"/>
        ],
        mobile_obj_img_set: [
            <img key={1} className="mobile_result_3_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Tiger-Animated.png"
                 alt="background"/>,
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_0_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_0_1.png",
        desc_set: [
            {
                desc_title: "다 살아본 호랑이",
                desc_sub_desc: "산에서도 살아보고, 정글에도 살아보고, 고시원에서도 살아본 호랑입니다.\n\n산전수전 다 겪어본 이들에게 쫄보라는 말은 전혀 어울리지 않아보이죠.\n하지만, 호랑이들이 처음부터 그랬던건 아니에요."
            }, {
                desc_title: "나는 두려움과 함께 성장한다.",
                desc_sub_desc: "5cm 정도 시공간이 오그라드는 말이지만, 이 보다 '다 살아본 호랑이'를 설명하기 좋은 말은 없을 것 같습니다. 호랑이들도 여느 동물들과 마찬가지로 두려움을 느낀답니다." +
                    "\n고양이과 동물들은 안정감을 찾기 위해 박스에 몸을 숨기곤 하잖아요.\n안정감을 찾는 다는 것은 반대로 두려움을 느낀다는 것! \n\n" +
                    "게다가 호랑이와 같은 맹수들도 사냥에 실패한 경우 큰 부상을 입곤 한다는 사실을 혹시 알고 계시나요? " +
                    "이 들은 매일 끼니를 해결하기 위해 목숨을 걸었고, 결국엔 이겨냅니다. 굳은 살 박힌 의지와 경험으로 어떤 두려움에도 도전하는게 테스터님과 참 닮았어요.\n\n" +
                    "못 믿겠다구요!?🙃 잘 생각해봐요! 우리가 살찜의 공포를 느끼면서도 매 끼니를 해결 하고 있다는 사실을!!! 농담이에요.🥰  겁 먹은 건 별로 상관 없어요. 이겨내고 해내느냐 못 해내느냐 의 차이죠.\n\n그리고 테스터님은 늘 해내지요. 앞으로도 그럴 수 있도록 우리가 응원합니다-!"
            },
        ],
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Sloth.png",
        couple_title: "나무늘보는 나무늘보",
        couple_desc: "“나무늘보 친구를 찾아보세요!”",
    },
    {
        sub_title: "쫄지 않는 쫄보",
        title: "나무늘보는 나무늘보",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Sloth-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Sloth-Web-FG-min.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Sloth-Insta.png",
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Eel.png",
        effect: ["leaf"],
        pc_obj_img_set: [
            <img key={1} className="result_2_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Sloth-Animated.png"
                 alt="background"/>
        ],
        mobile_obj_img_set: [
            <img key={1} className="mobile_result_2_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Sloth-Stable.png"
                 alt="background"/>
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_1_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_1_1.png",
        desc_set: [
            {
                desc_title: "나무늘보는 나무늘보",
                desc_sub_desc: "당신은 나무늘보는 나무늘보예요.\n 세상태평한 모습으로 나무에 매달려 세월아 네월아 입안에 든 풀을 씹고 있지요.\n\n 무서운 감정을 느끼는 감정 자체도 귀찮아서 공포가 뭔지도 까먹을 지경! 그런 나무늘보들에게도 반전이 있었으니..."
            }, {
                desc_title: "사실은 배짱있는 나무늘보!",
                desc_sub_desc: "나무늘보의 몸이 초록색으로 보이는 건, 나무늘보의 몸에서만 자라는 이끼 때문이래요.\n\n 오죽 움직이지 않고 가만히 있었으면 그랬을까요?" +
                    " 하지만 이것은 다 나무늘보의 생존전략 이에요! \n이끼는 보호색 역할 뿐아니라, 영양 섭취등 다양한 용도로 활용된다고 하네요.\n\n" +
                    "이 게으른 나무늘보가 일주일에 한 번 위험을 감수하고 나무에서 내려오는 순간이 있는데요. 바로, 배변활동을 하기 위해서라고 해요.\n\n시속 600m의 느린 몸으로 힘겨운 도전을 하는 나무늘보! 그 생존의지는 공포마저 극복한답니다. 평소 도전을 즐기지 않는 타입이지만, 할 때는 강단있게 확실히 하는 모습이 테스터님이랑 딱 닮았어요. " +
                    "\n\n남들 눈에는 게을러보여도 스스로 느리게 나아가고 있다는 사실을 잊지마세요-!"
            },
        ],
        couple_title: "배터리 없는 전기뱀장어",
        couple_desc: "“전기뱀장어 친구를 찾아보세요!”",
    },
    {
        sub_title: "강구석 여포형 쫄보",
        title: "이빨 떠는 피라냐",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Piranya-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Piranya-Web-FG-min.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Piranya-Insta.png",
        effect: ['bubble'],
        pc_obj_img_set: [
            <img key={1} className="result_1_main_obj result_1_fish"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Final-Animated-Piranha.png"
                 alt="background"/>
        ],
        mobile_obj_img_set: [
            <img key={1} className="mobile_result_1_main_obj mobile_result_1_fish"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Final-Animated-Piranha.png"
                 alt="background"/>
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_2_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_2_1.png",
        desc_set: [
            {
                desc_title: "이빨 떠는 피라냐",
                desc_sub_desc: "잉? 저건 이빨을 터는게 아니고 떠는거 같은데... 어찌 됐든 강구석 여포 피라냐 입니다. \n\n덩치 큰 짐승이고 뭐고 달려들어 물어재끼는 포악성! 용기! 딱 걸리면 커다란 물소도 1초만에 뼈만 남는다죠."
            },
            {
                desc_title: "“겁 먹는거 맛있는거야?”",
                desc_sub_desc: "당신은 천성적으로 겁을 느끼지 않는 사람이에요.\n 뭐 생각해보면, 살아온 어느 순간에 한 두 번쯤은 공포를 느껴봤을 수도 있지만, 글쎄요. 손에 꼽을 것 같아요. \n\n" +
                    "이용기는 친구들과 함께라면 훨~씬 더 강해집니다.\n\n" +
                    "피라냐 유형은 성격도 급한 편이라 하고 자 하는 일이 있다면, 누구보다 추진력있게 진행할 의지가 있지요.\n\n 하지만, 스스로의 상황을 고려하지 않고 행동부터 나설 때가" +
                    "있어요. 그렇게 준비되지 않은 액션은 가끔 좋지 않은 결과를 초래하기도 하지요.\n\n" +
                    "놀라울정도로 겁없는 추진력에 스스로를 제대로 이해하는 '자기인식' 그리고 판단력만 있다면, 정글의 진정한 지배자가 될 상입니다."
            },
        ],
        couple_title: "흐린 날의 오랑우탄",
        couple_desc: "“오랑우탄 친구를 찾아보세요!”",
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Orang.png",
    },
    {
        sub_title: "짜릿함을 즐기는 쫄보",
        title: "배터리 없는 전기뱀장어",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Eel-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Eel-Web-FG-min.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Eel-insta.png",
        effect: ["blue_shining", "spark", "bubble"],
        pc_obj_img_set: [
            <img key={3} className="result_4_main_obj result_eel"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Eel-Animated.png"
                 alt="background"/>,
        ],
        mobile_obj_img_set: [
            <img key={3} className="mobile_result_4_main_obj result_eel"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Eel-Animated.png"
                 alt="background"/>,
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_3_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_3_1.png",
        desc_set: [
            {
                desc_title: "배터리 없는 전기뱀장어",
                desc_sub_desc: "전기뱀장어는 찌릿찌릿 몸에서 코끼리 한 마리도 쓰러뜨릴 만큼의 전류를 방출한대요! 대단하죠?\n\n" +
                    "그러면 전기뱀장어의 몸은 안전할까요...? 그렇지 않다고 하네요. 엄청난 에너지 소모와 부상을 동반한다고 하는데요.\n\n 물론 위험한 상황에서만 전기를 방출하지만, 그 짜릿함을 즐기는 전기뱀장어! 바로 테스터님의 쫄보동물이랍니다. ⚡️"
            },
            {
                desc_title: "천둥을 불러일으키는 전기맨",
                desc_sub_desc: "쫄보동물 전기뱀장어 친구들은 타고난 모험가에요. 겁이 없다고 할 수 있는 사람은 아니지만, 음...🤔 어찌보면 겁이 많을 수도 있어요. \n\n" +
                    "하지만 정말 정말 도전하는걸 두려워하지 않지요. 무서운 상황이 있어도 절대 피하지 않아요. 사실 전기뱀장어 친구들이 짜릿함만을 즐기는건 아니에요.\n\n" +
                    " 짜릿함을 견뎌내고 이뤄내는 성취감을 즐기는거죠. \n\n높은 산 정상에 올랐을 때의 성취감, 나홀로 해외여행에 성공했을 때의 째지는 기분! 그런거를 너무너무 좋아하는거죠.\n\n" +
                    " 우리는 항상 테스터님의 그런 도전을 응원해요. 몸이든 마음이든 다치지 않도록 조금만 몸 사리시고...(물론, 모두 이겨내시겠지만요!) 더 멋진 일들 이뤄내기를 기원합니다.🙏"
            }
        ],
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Macaw.png",
        couple_title: "파랗게 질린 마카우",
        couple_desc: "“마카우 친구를 찾아보세요!”",
    },
    {
        sub_title: "롤러코스터형 쫄보",
        title: "흐린 날의 오랑우탄",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Orang-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Orang-Web-FG-min.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Orang-Insta.png",
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Coroco.png",
        effect: ["shining"],
        pc_obj_img_set: [
            <img key={0} className="result_7_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Orang-Animated-Low.png"
                 alt="background"/>
        ],
        mobile_obj_img_set: [
            <img key={0} className="mobile_result_7_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Orang-Stable.png"
                 alt="background"/>
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_4_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_4_1.png",
        desc_set: [
            {
                desc_title: "두 얼굴의 오랑우탄",
                desc_sub_desc: "장난치기를 좋아하는 다정한 오랑우탄입니다. 그러면서 또 성질부리기를 좋아하는 화가 난 오랑우탄입니다.\n\n" +
                    " 다정한 모습도, 화가난 모습도 모두 오랑우탄의 모습. 스스로의 감정에 매우매우 충실한 편이라는군요. \n\n그래서 그런지 어떨 땐 lv1 쪼랩 쫄보고, 어떨 땐 lv99에 3차승급 까지 마친 강심장이 되는 편."
            }, {
                desc_title: "감정수용력이 넘치는 감정쫄보",
                desc_sub_desc: "오랑우탄의 기분은 대체로 좋은 편이에요. 감수성이 높은 편이라 주변사람들의 기분을 재빨리 알아채곤 위로해주거나 용기를 북돋아 주기도 하죠.\n" +
                    "이 상태의 오랑우탄은 해피모드! 그러나 늘 해피모드인건 아니죠... \n\n" +
                    "오랑우탄의 기분이 다운되기 시작하면 그 끝을 알 수 가 없어요. 갓 떼를 밀어버린 피부처럼 예민해져서 주변에서 하는 말에 시큼하게 반응하거나, 크게 상처를 입기도 하지요. " +
                    "이 상태의 오랑우탄은 딥우울모드예요... \n\n기분과 반드시 연결되진 않지만, 두려움을 느끼는 정도도 경우에 따라 그 격차가 상당히 큰 편이에요. " +
                    "\n\n어떨 땐 아무리 무섭고 두려운 상황이라도 \"겁 없는 사람!\" 소리를 듣기도 하는 반면, 어떨 땐 \"이게 쫀다고?\" 라는 말을  들을만큼 진성 쫄보가 되어버리기도 한답니다. \n\n그게다 높은 감수성 때문이래요. 그 모습 그대로도 좋지만, 감정을 컨트롤 하는 연습을 한다면 최고로 멋진 정글쫄보동물이 될 거예요. 짝짝👏"
            },
        ],
        couple_title: "얼굴만 내민 악어",
        couple_desc: "“악어 친구를 찾아보세요!”",
    },
    {
        sub_title: "대기만성형 쫄보",
        title: "얼굴만 내민 악어",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Web-FG.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-insta.png",
        effect: ["shining"],
        pc_obj_img_set: [
            <img key={0} className="result_5_main_obj result_crocodile"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Animated-min.png"
                 alt="background"/>,
            <img key={1} className="result_foreground_img_2 foreground_zoom"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Web-FG1-min.png"
                 alt="background"/>,
            <img key={2} className="result_foreground_img_1 water_wave"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Web-FG2-min.png"
                 alt="background"/>,
            <img key={2} className="float_leaf float_leaf_wave"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Floated-min.png"
                 alt="background"/>,
        ],
        mobile_obj_img_set: [
            <img key={0} className="mobile_result_5_main_obj result_crocodile"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Animated-min.png"
                 alt="background"/>,
            <img key={1} className="mobile_result_foreground_img_2 foreground_zoom"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Web-FG1-min.png"
                 alt="background"/>,
            <img key={2} className="mobile_result_foreground_img_1 water_wave"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Crocodile-Web-FG2-min.png"
                 alt="background"/>,
            <img key={2} className="mobile_float_leaf mobile_float_leaf_wave"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Floated-min.png"
                 alt="background"/>,
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_5_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_5_1.png",
        desc_set: [
            {
                desc_title: "얼굴만 내민 악어",
                desc_sub_desc: "악어 타이틀이 어울리지 않게 겁 많은 '얼.만.악'을 소개할게요. 아직 어린 악어라서 사냥을 하기 보다는 몸을 좀 사릴 시기라고해요.\n\n 물론 이 다음에 커서 어른 악어가 되면 엄청 쎄져서 정글에 사는 다른 쫄보동물들을 다 잡아먹고 다니겠지만, 그게 지금은 아니랍니다. 😰"
            },
            {
                desc_title: "진정한 악어가 되기 위한 여정 🐊",
                desc_sub_desc: "아기 악어가 세상을 보는 방식은 조금 특별해요. 모든 것이 새롭게 느껴지지요. " +
                    "\n우리도 어릴 때 호기심에 가득 찬 눈으로 사물과 단어를 하나하나 살펴보곤 했잖아요.\n\n " +
                    "\"얼만악\"이 딱 그런 동물이에요. 그런데 조금 이상하네요. 호기심은 가득하지만, 도전하기는 꺼려하는 성향이 있는 것 같아요. \n\n그건, 상처받기 쉬운 마음을 가지고 있기 때문이에요. \n실패하지 않기 위해서 조금 겁쟁이처럼 보이지만, 정말 많은 준비를 하는 사람들이라고 할 수 있죠. \n\n당신이 유심히 살펴보는 모든 것 하나하나가 경험이 되고 배움이 될 거예요\n당신의 스타일 대로 열심히 준비하고,열심히 도전하다보면 큰 꿈을 이룰 날이 올거라고 믿어요! 🤘"
            }
        ],
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Tiger.png",
        couple_title: "다 살아본 호랑이",
        couple_desc: "“호랑이 친구를 찾아보세요!”",
    },
    {
        sub_title: "심장마비형 쫄보",
        title: "파랗게 질린 마카우",
        background_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Macaw-Web-BG-min.png",
        foreground_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Macaw-Web-FG-min.png",
        download_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Macaw-Insta.png",
        couple_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/friend/Friends-Piranya.png",
        effect: ["shining", "leaf"],
        pc_obj_img_set: [
            <img key={0} className="result_6_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Macaw-Animated-min.png"
                 alt="background"/>
        ],
        mobile_obj_img_set: [
            <img key={0} className="mobile_result_6_main_obj"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Macaw-Animated-min.png"
                 alt="background"/>
        ],
        ads_img_url: "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_6_0.png",
        banner_img_url:"https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/banner_6_1.png",
        desc_set: [
            {
                desc_title: "파랗게 질린 마카우",
                desc_sub_desc: "히야신스 마카우는 정말 멸종직전의 앵무새에요. 가장 큰 마카우 앵무새로도 알려져있지요. \n\n이 늠름하고 멋진 공룡의 후손이 바로 당신을 나타내는 쫄보유형입니다. \n세상 그 어느 새들 보다도 화려한 히야신스 마카우! 그런데 저 파란색이 사실은 파랗게 질린 얼굴이라면서요?"
            }, {
                desc_title: "💙#selfie#lovemyself",
                desc_sub_desc: "마카우는 원체 겁이 많아요. 구석에서 뭔가 조금만 움찔거려도 깜짝 놀라 자빠지곤하죠.\n" +
                    "자라보고 놀란 가슴 솥뚜껑보고 또 놀라는 유형. 그런데 또 놀란 티를 내는건 별로 안 좋아해요.\n\n" +
                    "그래서 생각한 두 가지 방법! 즐겁게 살기! 신나게 춤추고 즐겁게 살기도 바쁜 세상, 뭐하러 굳이 무서울 일을 만들겠어요~ 또, 여유로워 보이기!" +
                    " 인별그램에 뭐 구구절절 안 올리고 쉬크하게 이모티콘이나 몇 개 달아주는게 그야말로 여유와 힙의 상징이죠.\n\n" +
                    "워낙 낙천적이라 이런 삶도 꽤 잘 어울리는 편! 그래도 만약 무언가 도전해야 하는 시점이 온다면, 겁먹지 말고 한 번 뛰어들어보세요. 좀 더 풍요로운 삶이 기다리고 있을지도 모르잖아요-! \n\n오늘의 격언은 \"쫄지마,키 안 커\" 입니다. 💃"
            },
        ],
        couple_title: "이빨 떠는 피라냐",
        couple_desc: "“피라냐 친구를 찾아보세요!”",
    },
];

export const effect_set = {
    bubble: {
        pc: [
            <img key={10} className="bubble_1 effect_bubble_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={11} className="bubble_2 effect_bubble_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={12} className="bubble_3 effect_bubble_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={13} className="bubble_4 effect_bubble_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={14} className="bubble_5 effect_bubble_5"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>
        ],
        mobile: [
            <img key={10} className="bubble_1 mobile_effect_bubble_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={11} className="bubble_2 mobile_effect_bubble_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={12} className="bubble_3 mobile_effect_bubble_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={13} className="bubble_4 mobile_effect_bubble_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
            <img key={14} className="bubble_5 mobile_effect_bubble_5"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Bubble.png"
                 alt="background"/>,
        ]
    },
    shining: {
        pc: [
            <img key={15} className="shining_1 effect_shining_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
            <img key={16} className="shining_2 effect_shining_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
            <img key={17} className="shining_3 effect_shining_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
            <img key={18} className="shining_4 effect_shining_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>
        ],
        mobile: [
            <img key={15} className="mobile_shining_1 effect_shining_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
            <img key={16} className="mobile_shining_2 effect_shining_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
            <img key={17} className="mobile_shining_3 effect_shining_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
            <img key={18} className="mobile_shining_4 effect_shining_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-1.png"
                 alt="background"/>,
        ]
    },
    leaf: {
        pc: [
            <img key={19} className="result_2_object_1 result_2_leaf_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={20} className="result_2_object_1 result_2_leaf_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={21} className="result_2_object_1 result_2_leaf_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={22} className="result_2_object_1 result_2_leaf_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={23} className="result_2_object_1 result_2_leaf_5"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={24} className="result_2_object_1 result_2_leaf_6"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={25} className="result_2_object_1 result_2_leaf_7"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>
        ],
        mobile: [
            <img key={19} className="result_2_object_1 result_2_leaf_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={20} className="result_2_object_1 result_2_leaf_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={21} className="result_2_object_1 result_2_leaf_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={22} className="result_2_object_1 result_2_leaf_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={23} className="result_2_object_1 result_2_leaf_5"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={24} className="result_2_object_1 result_2_leaf_6"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>,
            <img key={25} className="result_2_object_1 result_2_leaf_7"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Leaf.png"
                 alt="background"/>
        ]
    },
    blue_shining: {
        pc: [
            <img key={26} className="shining_1 effect_shining_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>,
            <img key={27} className="shining_2 effect_shining_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>,
            <img key={28} className="shining_3 effect_shining_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>,
            <img key={29} className="shining_4 effect_shining_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>
        ],
        mobile: [
            <img key={26} className="mobile_shining_1 effect_shining_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>,
            <img key={27} className="mobile_shining_2 effect_shining_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>,
            <img key={28} className="mobile_shining_3 effect_shining_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>,
            <img key={29} className="mobile_shining_4 effect_shining_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Light-0.png"
                 alt="background"/>
        ]
    },
    spark: {
        pc: [
            <img key={30} className="spark_1 effect_spark_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={31} className="spark_2 effect_spark_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={32} className="spark_3 effect_spark_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={33} className="spark_4 effect_spark_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={34} className="spark_5 effect_spark_5"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={35} className="spark_6 effect_spark_6"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
        ],
        mobile: [
            <img key={30} className="mobile_spark_1 effect_spark_1"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={31} className="mobile_spark_2 effect_spark_2"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={32} className="mobile_spark_3 effect_spark_3"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={33} className="mobile_spark_4 effect_spark_4"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={34} className="mobile_spark_5 effect_spark_5"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
            <img key={35} className="mobile_spark_6 effect_spark_6"
                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/result/Effect-Electro.png"
                 alt="background"/>,
        ],
    }
};
